import { PRESUPUESTADOR_SET_PRICE_INCREASE } from './constants'

export function setPriceIncrease(value) {
    return {
        type: PRESUPUESTADOR_SET_PRICE_INCREASE,
        data: { resale_price_increase: value }
    }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_PRICE_INCREASE) {
        return {
            ...state,
            nuevo: {
                ...state.nuevo,
                resale_price_increase: action.data.resale_price_increase
            },
            resale_price_increase: action.data.resale_price_increase,
        }
    }
    return state
}
